import { useEffect, useContext } from 'react';
import ServerSideService from '../services/server-side-service/server-side-service';
import ServerContext from '../contexts/serverContext';

const useFooterDisplay = (dependencies: any[] = [], timeout = 1000) => {
    const serverContext = useContext(ServerContext);
    useEffect(() => {
        if (ServerSideService.isClientSide()) {
            setTimeout(() => {
                const footer =
                    serverContext.brand === 'ford'
                        ? document.getElementById('owner-syndicated-footer')
                        : document.getElementById('lincon-syndicated-footer');

                if (footer) footer.style.display = 'block';
            }, timeout);
        }
    }, dependencies);
};

export default useFooterDisplay;
